module.exports = __webpack_public_path__ + "img/cpany20.ee3c4f25.png";